// PARAQTA — Mobile Bottom Nav (Step N1).
// Static HTML index.html-де; JS міндеті — show() тыс sync жасау
// (active tab class on/off).
// router.js show() ішінен setActiveBnav() шақырылады.

export function setActiveBnav(target) {
  const root = document.getElementById('bnav');
  if (!root) return;
  root.querySelectorAll('.bnav-tab').forEach(b => b.classList.remove('on'));
  const active = root.querySelector(`.bnav-tab[data-target="${target}"]`);
  if (active) active.classList.add('on');
}
